import { render, staticRenderFns } from "./TabPriceList.vue?vue&type=template&id=b60a6ce8&"
import script from "./TabPriceList.vue?vue&type=script&lang=js&"
export * from "./TabPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports